import React, { useEffect } from "react";

export default function InsightsHelpModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(180,125,232,0.08)",
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "24px",
        boxSizing: "border-box",
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "rgba(21, 61, 96, 100.0)",
          padding: "24px",
          borderRadius: "12px",
          width: "90%",
          maxWidth: "440px",
          color: "white",
          boxShadow: "0 0 20px rgba(0,0,0,0.4)",
          maxHeight: "80vh",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: "16px" }}>Understanding Your Insights</h3>

        <>
          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Intention Alignment</strong>
            <br />
            Shows how closely each session matched the intention you set beforehand.
            Lower scores do not mean a session was unsuccessful. Some journeys simply
            reveal something different than what you expected.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>NS (Nervous System Shift)</strong>
            <br />
            A before and after comparison of your nervous system state. This can help
            you see whether a session tended to leave you more grounded, open,
            activated, or reflective.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Set &amp; Setting Patterns</strong>
            <br />
            Highlights how time of day, physical environment, and your emotional state
            before the session may influence your outcomes.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Strain Performance</strong>
            <br />
            Shows which strains or varieties appear most consistently
            connected to positive or meaningful sessions.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Type × Amount Patterns</strong>
            <br />
            Shows how different types or amount ranges relate to your reported experiences, helping you notice what tends to feel most aligned for you.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Body Activation</strong>
            <br />
            Shows where journeys are most often felt in the body, helping reveal
            recurring somatic patterns across sessions.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Integration Rate</strong>
            <br />
            The percentage of journeys where you returned afterward to reflect, journal,
            or record what stayed with you.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            <strong>Sessions Worth Revisiting</strong>
            <br />
            Highlights sessions that stood out based on strong alignment, unusual
            shifts, or meaningful themes that may deserve another look.
          </p>

          <p style={{ fontSize: "14px", opacity: 0.85 }}>
            These insights are not meant to define your experiences. They are here to
            help you better understand your personal patterns over time.
          </p>
        </>

        <button
          onClick={onClose}
          style={{
            marginTop: "16px",
            width: "100%",
            padding: "10px",
            background: "#7dd3e8",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "600",
            color: "#000"
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}